export default __webpack_public_path__ + "static/media/foam-filling-material.af765d0d.webp";